import { lazy } from "react";

const KEY = "cts_chunk_reload_at";
const RE = /ChunkLoadError|Loading (CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

export const isChunkError = (e) => !!e && RE.test(`${e.name || ""} ${e.message || e}`);

// One hard reload per minute at most (stale tab after a re-publish); returns false when the guard blocks it.
export const reloadOnce = () => {
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 60000) return false;
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
  return true;
};

export const hardReload = () => {
  sessionStorage.removeItem(KEY);
  window.location.reload();
};

// React.lazy with one retry, then a single guarded reload; otherwise the route error card takes over.
export const lazyRetry = (factory) => lazy(() => factory().catch((e) => {
  if (!isChunkError(e)) throw e;
  return new Promise((r) => setTimeout(r, 400)).then(factory).catch((e2) => {
    if (isChunkError(e2) && reloadOnce()) return new Promise(() => {});
    throw e2;
  });
}));
